const TOKEN_KEY = 'galax_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setSession = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem('galax_current_user');
  localStorage.removeItem('galax_employee');
};

// Skickar inloggningen med automatiskt till alla funktionsanrop
if (typeof window !== 'undefined' && !window.__galaxFetchPatched) {
  window.__galaxFetchPatched = true;
  const orig = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const token = getToken();
    if (token && url.startsWith('/.netlify/functions/')) {
      init = { ...init, headers: { ...(init.headers || {}), Authorization: `Bearer ${token}` } };
    }
    return orig(input, init);
  };
}

class Query {
  constructor(table) {
    this.t = { table, op: 'select', columns: '*', values: null, filters: [], order: [], limit: null, single: false };
  }
  select(cols = '*') { if (this.t.op === 'select') this.t.columns = cols; return this; }
  insert(values) { this.t.op = 'insert'; this.t.values = values; return this; }
  update(values) { this.t.op = 'update'; this.t.values = values; return this; }
  upsert(values) { this.t.op = 'upsert'; this.t.values = values; return this; }
  delete() { this.t.op = 'delete'; return this; }
  _f(type, col, val) { this.t.filters.push({ type, col, val }); return this; }
  eq(c, v) { return this._f('eq', c, v); }
  neq(c, v) { return this._f('neq', c, v); }
  ilike(c, v) { return this._f('ilike', c, v); }
  gte(c, v) { return this._f('gte', c, v); }
  lte(c, v) { return this._f('lte', c, v); }
  is(c, v) { return this._f('is', c, v); }
  order(col, opts = {}) { this.t.order.push({ col, ascending: opts.ascending !== false }); return this; }
  limit(n) { this.t.limit = n; return this; }
  single() { this.t.single = true; return this; }
  maybeSingle() { this.t.single = 'maybe'; return this; }

  async _run() {
    try {
      const res = await fetch('/.netlify/functions/db', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(this.t)
      });
      const out = await res.json().catch(() => ({ data: null, error: { message: 'Serverfel' } }));
      if (res.status === 401 && out.error && out.error.code === 'SESSION_EXPIRED') {
        clearSession();
        window.location.href = '/login';
      }
      return { data: out.data === undefined ? null : out.data, error: out.error || null };
    } catch (e) {
      return { data: null, error: { message: e.message || 'Nätverksfel' } };
    }
  }

  then(resolve, reject) { return this._run().then(resolve, reject); }
}

export const supabase = { from: (table) => new Query(table) };
